import React, { useState, useEffect, useRef } from 'react';
import '../styles/ModeSelector.css';

const MODES = [
  { id: 'conversations', label: 'Conversations', icon: '💬', enabled: true },
  { id: 'domains', label: 'Domains', icon: '🌐', enabled: true },
  { id: 'sites', label: 'Hosted Sites', icon: '🏠', enabled: true },
  { id: 'documents', label: 'Documents', icon: '📄', enabled: true },
  { id: 'apps', label: 'Apps', icon: '🚀', enabled: false },
];

export default function ModeSelector({ mode, onModeChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const current = MODES.find((m) => m.id === mode) || MODES[0];

  return (
    <div className="mode-selector" ref={ref}>
      <button
        className="mode-selector-trigger"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="mode-selector-label">{current.label}</span>
        <span className={`mode-selector-chevron ${open ? 'open' : ''}`}>▼</span>
      </button>

      {open && (
        <div className="mode-selector-dropdown" role="listbox">
          {MODES.map((m) => (
            <button
              key={m.id}
              className={`mode-selector-option ${m.id === mode ? 'active' : ''} ${!m.enabled ? 'disabled' : ''}`}
              onClick={() => {
                if (m.enabled) {
                  onModeChange(m.id);
                  setOpen(false);
                }
              }}
              disabled={!m.enabled}
              role="option"
              aria-selected={m.id === mode}
            >
              <span className="mode-option-icon">{m.icon}</span>
              <span className="mode-option-label">{m.label}</span>
              {!m.enabled && <span className="mode-option-badge">Coming Soon</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
